import * as QRCode from 'qrcode-js-package';

export default function generateQR(data = '', config = {}, htmlElement = document.createElement('DIV')) {
  const qr = new QRCode(htmlElement, config);
  qr.makeCode(data);

  return qr;
}
